/* eslint-disable react/prop-types */
import React from 'react';
import { Grid } from '@material-ui/core';

export const KeyValueItems: React.FC = ({ children }) => {
    return (
        <Grid container={true} spacing={2}>
            {children}
        </Grid>
    );
};
